export const FETCH_SHOP = 'app/core/FETCH_SHOP';
export const SET_SHOP = 'app/core/SET_SHOP';
export const FETCH_VENDOR_CONFIG_NOTES = 'app/core/FETCH_VENDOR_CONFIG_NOTES';
export const TOGGLE_FAVORITES = 'app/favorites/TOGGLE_FAVORITES';
